import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  InputGroup,
  Spinner,
} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './PPList.css';
import PPOffCanvasComponent from '../../Stocks/PPOffCanvasComponent';
import { getPlants } from '../../../api/processing plant/plantApi';
import ppdefault from '../../../assets/images/ppdefault.png';

const ProcessingPlantList = () => {
  const [show, setShow] = useState(false);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [plant, setPlant] = useState([]); // Initialize as an array
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState(''); // State for search term

  // Fetch all profiles and their orders/newStock counts
  const fetchAllPlants = async () => {
    setLoading(true);
    try {
      const response = await getPlants();
      const profiles = response.data || []; // Extract the data array from the response
      console.log('response plant', profiles);
      setPlant(profiles);
    } catch (error) {
      console.error('Error fetching profiles:', error);
      setPlant([]); // Set empty array on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllPlants();
  }, []);

  const handlePlantClick = (id) => {
    setSelectedOwner(id);
    setShow(true);
  };

  const toggleModal = () => {
    setShow(!show);
    if (show) setSelectedOwner(null);
  };

  // Filter plants based on search term
  const filteredPlants = plant.filter((plant) =>
    plant.companyName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ minHeight: '100%', marginTop: '100px', padding: '30px' }}>
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="mb-0">Processing Plants</h4>
          <div className="d-flex align-items-center">
            <InputGroup style={{ width: '200px' }}>
              <Input
                placeholder="Search by Company Name"
                className="rounded2"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)} // Update search term on input change
              />
            </InputGroup>
          </div>
        </div>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: '200px' }}
          >
            <Spinner color="primary" />
          </div>
        ) : filteredPlants.length === 0 ? (
          <div
            className="text-center"
            style={{
              minHeight: '200px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <h5>No processing plants found.</h5>
          </div>
        ) : (
          <Row>
            {filteredPlants.map((plant, index) => (
              <Col
                xs="12"
                sm="6"
                md="4"
                lg="3"
                key={plant._id || index} // Use _id if available, otherwise fall back to index
                className="mb-4"
              >
                <Card>
                  <CardBody className="text-left">
                    <div className="d-flex">
                      <img
                        style={{ margin: '0px 18px' }}
                        src={plant.profileImage || ppdefault}
                        className="avatar-placeholder mb-3"
                        alt="Owner"
                      />
                      <div style={{ marginTop: '5px' }}>
                        <span
                          style={{
                            fontWeight: 'bold',
                            fontSize: '24px',
                            cursor: 'pointer',
                          }}
                          className="mb-1"
                          onClick={() => handlePlantClick(plant._id)}
                        >
                          {plant.companyName}
                        </span>
                        <div className="d-flex justify-content-left align-items-center mb-2">
                          <span
                            style={{
                              position: 'relative',
                              fontSize: '24px',
                              marginRight: '8px',
                              bottom: '2px',
                            }}
                            className="star-icon mr-1"
                          >
                            ★
                          </span>
                          <span style={{ fontSize: '18px' }}>
                            {plant.rating || 'N/A'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        )}
        <style jsx>{`
          .avatar-placeholder {
            width: 80px;
            height: 80px;
            background-color: #e0e0e0;
            border-radius: 50%;
            object-fit: cover;
          }
          .star-icon {
            color: #ffd700;
            font-size: 1.2rem;
          }
          .card {
            transition: transform 0.2s;
          }
          .card:hover {
            transform: translateY(-5px);
          }
        `}</style>
        <PPOffCanvasComponent
          isOpen={show}
          onToggle={toggleModal}
          plantId={selectedOwner} // Pass selected owner details
        />
      </Container>
    </div>
  );
};

export default ProcessingPlantList;
